<template>
  <div class="pageContol listWrap templateList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;" @click="goHerf()">班级列表</a>
          <i>></i>
          <a href="javascript:;" @click="init" class="cur-a">{{ projectName }}-详情</a>
        </span>
      </div>
      <div class="framePage-body framePage-tabs">
        <el-tabs
          v-model="activeName"
          :before-leave="beforeTabLeave"
          @tab-click="tabChange"
        >
          <el-tab-pane label="基本信息" name="first">
            <editClassCtr ref="first" />
          </el-tab-pane>
          <el-tab-pane label="课程列表" name="second">
            <CourseList ref="second" />
          </el-tab-pane>
          <el-tab-pane label="学员列表" name="three">
            <!-- 判断是否长春对接得 -->
            <changchunStudentList ref="three" v-if="projectSource == '20'" />
            <!-- 判断是否山西对接得 -->
            <shanxiStudentList ref="three" v-else-if="projectSource == '50'" />
            <!-- 判断是否甘肃对接得 -->
            <gsStudentList
              ref="three"
              v-else-if="
              (zF.getString2(areaId,4) == 6201 || zF.getString2(areaId,4) == 6240 || zF.getString2(areaId,4) == 6205) && trainTypeNamePath.indexOf('职业技能') > -1
              "
            />
            <!-- 普通学员列表 -->
            <StudentList ref="three" v-else />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import List from "@/mixins/List";
import editClassCtr from "@/views/classListCom/editClassCtr.vue";
import CourseList from "@/views/classListCom/classDetailsFile/CourseList.vue";
import StudentList from "@/views/classListCom/classDetailsFile/StudentList.vue";
import gsStudentList from "@/views/classListCom/gsStudentList.vue";
import changchunStudentList from "@/views/classListCom/changchunStudentList.vue";
import shanxiStudentList from "@/views/classListCom/shanxiStudentList.vue";
import { mapGetters } from "vuex";

export default {
  name: "ClassdetailsList",
  components: {
    editClassCtr,
    CourseList,
    StudentList,
    changchunStudentList,
    shanxiStudentList,
    gsStudentList,
  },
  mixins: [List],
  data() {
    return {
      activeName: "",
      projectName: "",
      sjz: this.$route.query.sjz,
    };
  },
  mounted() {

  },
  watch: {
    activeName: function (nval, oval) {
      if (nval && nval != "first") {
        this.$refs[nval].getData();
        this.$refs[nval].getData();
        if (nval == "three") {
          this.$refs.three.openOnce();
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      userJson: "getUser",
    }),
  },
  methods: {
    init() {
      this.projectName = sessionStorage.getItem("projectName");
      this.projectId = sessionStorage.getItem("projectId");
      this.areaId = sessionStorage.getItem("areaId");
      this.trainTypeNamePath = sessionStorage.getItem("trainTypeNamePath");
      this.projectSource = sessionStorage.getItem("projectSource");
      this.trainTypeId = sessionStorage.getItem("trainTypeId");
      const query = this.$route.query;
      if (query.active) {
        this.activeName = query.active;
      }
    },
    tabChange(tab) {
      this.activeName = tab.name;
      this.$refs[tab.name].userName = "";
      this.$refs[tab.name].idcard = "";
      this.$refs[tab.name].mobile = "";
      this.$refs[tab.name].completeState = "";
      if (this.projectSource == "20" && this.trainTypeId == "16") {
        this.$refs.second.getTreeTrain();
      }
    },
    beforeTabLeave(newName) {
      this.$router.replace({
        path: this.$route.path,
        query: { active: newName },
      });
    },
    goHerf() {
      if (this.sjz) {
        this.$router.push({
          name: "sjz/jg/classList"
        });
      } else {
        if (this.projectSource != "30") {
          this.$router.push({
            name: "classListCtr",
            params: {
              refresh: true,
              isAdd: false,
            },
          });
        } else {
          this.$router.back();
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.framePage-tabs {
  flex: 1;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0%;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  position: relative;
  background-color: #fff;
  padding: 1rem 0.675rem;
  box-sizing: border-box;
}
#pane-first {
  display: flex;
  flex: 1;
  overflow: hidden;
}
</style>
<style lang="less">
.framePage-tabs {
  .el-tabs {
    width: 100%;
  }
  .el-tabs__content {
    overflow-y: auto;
  }
}
</style>
